<div class="drop-shadow-card flex min-h-0 w-full grow flex-col rounded-xl bg-white">
  @if (displayHeader()) {
    <div
      class="border-b-theme-blue-gray flex h-fit w-full flex-row items-center gap-x-3 border-b p-1 pl-4">
      <!--TODO icon selection may be generic-->
      <img
        src="../../../assets/icons/table-list-solid.svg"
        loading="lazy"
        alt=""
        class="h-7 invert-[80%] filter" />
      <span class="flex items-center gap-4 p-1 text-lg font-bold">
        <span class="py-3">{{ currentTableModel().label }}</span>
        @if (this.suggestedSumControl?.invalid) {
          <ct-extraction-warning>
            <ng-template #content>
              <span class="!text-warning material-icons">warning</span>
              <span>
                Die Summe der Einzelbeträge stimmt nicht mit der<br />Gesamtforderung überein. Bitte
                überprüfe beide
              </span>
            </ng-template>
          </ct-extraction-warning>
        }
      </span>
    </div>
  }

  <ct-extraction-remove-all-rows-dialog
    [dialogKey]="removeAllRowsDialogKey()"
    [rowCount]="tableRows().length"
    (acceptedDialog)="removeAllRows()" />

  @if (!tableRows().length) {
    @if (hasMultipleTableSections()) {
      <div class="flex w-full justify-center p-4">
        <button
          class="group flex w-fit flex-row gap-x-2 rounded-md border p-2 hover:bg-gray-500"
          (click)="startManualCreation()">
          <img
            alt=""
            src="../../../assets/icons/table-list-solid.svg"
            loading="lazy"
            class="invert-[80%] filter" />
          <span>Tabelle anlegen</span>
        </button>
      </div>
    } @else {
      <div
        class="flex max-h-full w-full grow flex-col items-center justify-center gap-4 overflow-y-auto">
        <div class="m-auto flex flex-col items-center gap-4 p-16 text-center">
          <img src="../../../assets/images/generate_table.svg" loading="lazy" alt="" />
          <p class="text-theme-blue w-fit text-xl break-normal">
            Zeichne eine Tabelle direkt ins Dokument oder erstelle die Tabelle manuell
          </p>
          <button
            class="group flex w-fit flex-row gap-x-2 rounded-md border p-4 hover:bg-gray-500"
            (click)="startManualCreation()">
            <img
              alt=""
              src="../../../assets/icons/table-list-solid.svg"
              loading="lazy"
              class="invert-[80%] filter" />
            <span class="uppercase">Manuell erstellen</span>
          </button>
        </div>
      </div>
    }
  } @else {
    <div class="min-h-0 grow overflow-y-auto" [style.scrollbar-gutter]="'stable'">
      <ct-extraction-table
        [capturingConfig]="capturingConfig()"
        [hasActionButtonInRows]="true"
        [tableRows]="tableRows()"
        [isClassificationView]="false"
        [isActive]="isActiveSection()"
        [(currentFieldIndex)]="currentTableFieldIndex"
        (rowAdded)="addRowAtIndex($event.index, $event.tableId)"
        (rowDeleted)="removeRowAtIndex($event)"
        (currentTableCellChange)="onTableCellChange($event)" />
    </div>
    @if (suggestedSumControl) {
      <div
        class="flex shrink-0 flex-col gap-2 overflow-auto py-4 pr-2 pl-4"
        [style.scrollbar-gutter]="'stable'">
        @let model = suggestedSumModel;
        @let control = suggestedSumControl;
        <!-- Column fractions and the trailing 26px mirror a table row, so the input lines up. -->
        <div class="flex flex-row items-center gap-1">
          <span class="w-9/12 text-right font-bold">{{ model.label.text }}</span>
          <!-- TODO: we could refactor the classList with error / focus states into a directive -->
          <div class="w-4/12 min-w-0">
            <input
              ctExtractionCurrencyInput
              class="w-full rounded border p-1 ring-1"
              [attr.data-testid]="suggestedSumModel.key"
              [formControl]="control"
              (focusin)="onSuggestedSumControlFocus()"
              [ngClass]="
                inputStylingService.getDefaultInputClasses(
                  control.value,
                  currentFieldModel()?.key === suggestedSumModel.key,
                  control.invalid
                ) +
                ' ' +
                (control.valid && suggestedSumDisplayValue()
                  ? 'border-theme-green-500 ring-theme-green-500'
                  : '')
              "
              [appTooltip]="control.invalid ? errorText(control) : ''" />
          </div>
          <span class="w-[26px] shrink-0"></span>
        </div>
        <div class="flex flex-row gap-1">
          <span
            class="ml-auto whitespace-nowrap"
            [ngClass]="control.invalid ? 'visible' : 'invisible'">
            Summe Einzelbeträge: {{ suggestedSumDisplayValue() }}
          </span>
          <span class="w-[26px] shrink-0"></span>
        </div>
      </div>
    }
  }
</div>
